import Events from 'events';

export default class EventsFallback extends Events {
  constructor(...args) {
    super(...args);
    this.eventNames = [];
    this.customListeners = [];
  }

  listenTo(object, name, callback) {
    this.customListeners.push({
      object,
      name,
      callback: callback.bind(this),
    });
    object.on(name, callback.bind(this));
  }

  on(eventName, callback) {
    if (typeof callback === 'undefined') {
      return;
    }
    this.eventNames.push(eventName);
    this.addListener(eventName, callback);
  }

  off(...args) {
    const validArgs =
      typeof args !== 'undefined' && Array.isArray(args) && args.length >= 1;

    if (validArgs) {
      return this.removeListener(...args);
    }
    this.eventNames.forEach((name) => this.removeAllListeners(name));
  }

  trigger(eventName, ...args) {
    this.emit(eventName, ...args);
  }

  stopListening() {
    this.customListeners.forEach((listener) => {
      listener.object.off(listener.name, listener.callback);
    });
  }
}
